import { makeStyles } from "@material-ui/core";
import React from "react";
import ImageLoader from "src/components/image-loader/ImageLoader";
import UploaderDesignerTool from "src/components/util/uploader-designer-tool";
import CkService from "src/services/CkService";
import slug from '@sindresorhus/slugify';
import { remove_non_ascii, getYear, getMonth, getDate } from '../../../utils/common';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "grid",
    gridTemplateColumns: "2.5fr 1fr",
    columnGap: "1rem",
  },
  avatarItem: {
    border: "0.5px dashed blue",
  },
  title: {
    color: "black",
  },
}));

const ChangeThumbnailPost = ({ post, updatePost, updatePostCover, showSnackBar }) => {
  const classes = useStyles();
  const crop_ver = {
    unit: "px",
    width: 750,
    minWidth: 750,
    aspect: 10 / 16,
    x: 0,
    y: 0,
  };
  const crop_hor = {
    unit: "px",
    width: 1200,
    minWidth: 1200,
    aspect: 16 / 10,
    x: 0,
    y: 0,
  };

  if (!post) {
    return <></>;
  }

  const noneedcrop = (data) => {
    const { type, url } = data;
    updatePost(post, {
      ...(type === "vertical" && { img_ver: url }),
      ...(type === "horizontal" && { img_hor: url }),
    });
    showSnackBar({
      mess: "Đã cập nhật thumbnail",
      type: "success",
    });
  };
  const noneedcropcover = (data) => {
    const { type, url } = data;
    updatePostCover(post, {
      ...(type === "vertical" && { cover_m: url }),
      ...(type === "horizontal" && { cover_pc: url }),
    });
    showSnackBar({
      mess: "Đã cập nhật cover",
      type: "success",
    });
  };

  const handleImageCrop = (data) => {
    const tmp_id = post.tmp_id || post.id;
    const fy = getYear(post.createdAt);
    const fm = getMonth(post.createdAt);
    const fdate = getDate(post.createdAt);
    const editor_type = post.editor_type || "normal";
    const { type, blob } = data;
    if (blob == "") {
      updatePost(post, {
        ...(type === "vertical" && { img_ver: "" }),
        ...(type === "horizontal" && { img_hor: "" }),
      });
    } else {
      fetch(blob)
        .then((res) => res.blob())
        .then((blob) => {
          const fd = new FormData();
          let dataFileNm = data.filename.toLowerCase();
          let fileType = dataFileNm.split(".").pop();
          let fileName = slug(dataFileNm.replace(`.${fileType}`, ""));
          dataFileNm = fileName + "." + fileType;
          dataFileNm = remove_non_ascii(dataFileNm);
          const file = new File([blob], dataFileNm);
          fd.append("upload", file);
          CkService.upload(
            `/s3/core/connector/php/connector.php?command=FileUpload&lang=vi&type=Images&currentFolder=%2F&hash=e6f15ae802bbf5fe&responseType=json&type=Images&responseType=json&id=${tmp_id}&editorType=${editor_type}&fy=${fy}&fm=${fm}&fd=${fdate}`,
            fd
          )
            .then((result) => {
              let file = result.data;
              let nameImg = encodeURI(file.currentFolder.url + file.fileName);
              updatePost(post, {
                ...(type === "vertical" && { img_ver: nameImg }),
                ...(type === "horizontal" && { img_hor: nameImg }),
              });
              showSnackBar({
                mess: "Đã cập nhật thumbnail",
                type: "success",
              });
            })
            .catch((error) => {
              // upload fail
              console.log(error);
            });
        });
    }
  };

  const handleImageCropCover = (data) => {
    const tmp_id = post.tmp_id || post.id;
    const fy = getYear(post.createdAt);
    const fm = getMonth(post.createdAt);
    const fdate = getDate(post.createdAt);
    const editor_type = post.editor_type || "normal";
    const { type, blob } = data;
    if (blob == "") {
      updatePostCover(post, {
        ...(type === "vertical" && { cover_m: "" }),
        ...(type === "horizontal" && { cover_pc: "" }),
      });
    } else {
      fetch(blob)
        .then((res) => res.blob())
        .then((blob) => {
          const fd = new FormData();
          let dataFileNm = data.filename.toLowerCase();
          let fileType = dataFileNm.split(".").pop();
          let fileName = slug(dataFileNm.replace(`.${fileType}`, ""));
          dataFileNm = fileName + "." + fileType;
          dataFileNm = remove_non_ascii(dataFileNm);
          const file = new File([blob], dataFileNm);
          fd.append("upload", file);
          CkService.upload(
            `/s3/core/connector/php/connector.php?command=FileUpload&lang=vi&type=Images&currentFolder=%2F&hash=e6f15ae802bbf5fe&responseType=json&type=Images&responseType=json&id=${tmp_id}&editorType=${editor_type}&fy=${fy}&fm=${fm}&fd=${fdate}`,
            fd
          )
            .then((result) => {
              let file = result.data;
              let nameImg = encodeURI(file.currentFolder.url + file.fileName);
              updatePostCover(post, {
                ...(type === "vertical" && { cover_m: nameImg }),
                ...(type === "horizontal" && { cover_pc: nameImg }),
              });
              showSnackBar({
                mess: "Đã cập nhật cover",
                type: "success",
              });
            })
            .catch((error) => {
              // upload fail
              console.log(error);
            });
        });
    }
  };

  return (
    <div className="mt-5">
      <h3 className={classes.title}>
        Bài viết: <b>{post.title}</b>
      </h3>
      <h4 className="mt-5">Thumbnail</h4>
      <div className={classes.wrapper}>
        <div className={classes.avatarItem}>
          <UploaderDesignerTool
            dragagain={true}
            tmp_id={post.tmp_id || post.id}
            url={post.img_hor}
            crop={crop_hor}
            type="horizontal"
            noneedcrop={noneedcrop}
            handleImageCrop={handleImageCrop}
            post={post}
            // no_crop={true}
          />
        </div>
        <div className={classes.avatarItem}>
          <UploaderDesignerTool
            dragagain={true}
            tmp_id={post.tmp_id || post.id}
            url={post.img_ver}
            crop={crop_ver}
            type="vertical"
            noneedcrop={noneedcrop}
            handleImageCrop={handleImageCrop}
            post={post}
            // no_crop={true}
          />
        </div>
      </div>
      {(post.cover_pc || post.cover_m) && (
        <React.Fragment>
          <h4 className="mt-5">Cover</h4>
          <div className={classes.wrapper}>
            <div className={classes.avatarItem}>
              <UploaderDesignerTool
                dragagain={true}
                tmp_id={post.tmp_id || post.id}
                url={post.cover_pc}
                type="horizontal"
                noRequireSize={true}
                noneedcrop={noneedcropcover}
                handleImageCrop={handleImageCropCover}
                no_crop={true}
                post={post}
              />
            </div>
            <div className={classes.avatarItem}>
              <UploaderDesignerTool
                dragagain={true}
                tmp_id={post.tmp_id || post.id}
                url={post.cover_m}
                noRequireSize={true}
                type="vertical"
                noneedcrop={noneedcropcover}
                handleImageCrop={handleImageCropCover}
                no_crop={true}
                post={post}
              />
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default ChangeThumbnailPost;
